import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { ContentContainer, MainContainer } from '@atoms/tableData/styles/contentContainer.styles';
import GcspTable from '@templates/gcsp/forecast/tableComponent/gcspTable';
import SubHeaderGcsp from '@molecules/gcsp/components/subHeaderGcsp';
import DashboardAlerts from '@organisms/alertBar/dashboardAlerts';
import SpinnerLoader from '@atoms/SpinnerLoader';
import SubHeaderTopGcsp from '@molecules/gcsp/components/subHeaderTopGcsp';
import { PAGE } from '../../constants/commonConstants';

const GcspForecast = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadingTimer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(loadingTimer);
  }, []);

  const CenteredSpinner = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `;

  return (
    <MainContainer>
      <ContentContainer>
        <SubHeaderTopGcsp />
        <SubHeaderGcsp />
        <DashboardAlerts screenName={PAGE.FORECAST} />
        {isLoading ? (
          <CenteredSpinner>
            <SpinnerLoader color="#155CB4" />
          </CenteredSpinner>
        ) : (
          <GcspTable />
        )}
      </ContentContainer>
    </MainContainer>
  );
};

export default GcspForecast;
